import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { TextBase } from './text.base.js';
import { base } from './text.css.js';

/**
 * Build a `Text.*` element with its default variant baked in. Centralizes the `forwardRef`
 * plumbing; all rendering logic lives in `TextBase`.
 *
 * @param element The HTML tag this entry renders.
 * @param defaultVariant Variant applied when the caller doesn't pass one.
 * @param extraClassName Extra class merged before the caller's `className`. Used for per-element
 *   defaults like `font-style: italic` on `Text.em` or the list reset on `Text.ul` / `Text.ol`.
 */
function create(element, defaultVariant, extraClassName) {
    const Component = forwardRef((
    // TS can't narrow `IntrinsicTextProps<T>` enough to destructure `variant`/`className`
    // inline (the `Override<JSX.IntrinsicElements[T], TextProps>` shape stays generic), so
    // we widen here. The forwardRef generic still types the public API correctly.
    { className, variant = defaultVariant, ...props }, ref) => (jsx(TextBase, { "data-fpl-component": "", ...props, as: element, variant: variant, className: clsx(extraClassName, className, base), ref: ref })));
    Component.displayName = `Text.${element}`;
    return Component;
}

export { create };
//# sourceMappingURL=text.create.js.map
